class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const self = this;
    const container = self.querySelector('#product-options');
    const btn = self.querySelector('.product-options-trigger');
    let containerHeight = 0;

    if (!container) return;

    if (btn) {
      btn.addEventListener('click', function () {
        self.classList.add('show-options');
      });
    }

    function applyHeight() {
      containerHeight = container.offsetHeight;
      self.style.minHeight = `${containerHeight}px`;

      if (containerHeight > 80) {
        self.classList.add('has-options');
      } else {
        self.classList.remove('has-options');
      }
    }

    // Detect iOS Safari
    function isIOSSafari() {
      const ua = window.navigator.userAgent;
      const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
      const webkit = !!ua.match(/WebKit/i);
      const iOSSafari = iOS && webkit && !ua.match(/CriOS/i) && !ua.match(/FxiOS/i);
      return iOSSafari;
    }

    // Use Intersection Observer to detect element visibility
    function setupVisibilityObserver() {
      let targetElement;

      // On iOS Safari, observe the currency dropdown for earlier hiding
      // On other browsers, observe the footer
      if (isIOSSafari()) {
        targetElement = document.querySelector('localization-form') ||
                        document.querySelector('.footer__localization') ||
                        document.querySelector('footer') ||
                        document.querySelector('#shopify-section-footer');
      } else {
        targetElement = document.querySelector('footer') ||
                        document.querySelector('#shopify-section-footer');
      }

      if (!targetElement) return;

      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0
      };

      const visibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (window.innerWidth <= 767) {
            if (entry.isIntersecting) {
              self.classList.add('footer-visible');
            } else {
              self.classList.remove('footer-visible');
            }
          }
        });
      }, observerOptions);

      visibilityObserver.observe(targetElement);
    }

    setTimeout(function () {
      applyHeight();
      setupVisibilityObserver();
    }, 1000);

    window.addEventListener('resize', function () {
      applyHeight();
    });

    window.addEventListener('scroll', function () {
      if (window.innerWidth <= 767) {
        const scroll = window.scrollY || window.pageYOffset;
        const targetOffset = self.offsetTop;

        if (scroll >= targetOffset + containerHeight) {
          self.classList.add('is-fixed');
        } else {
          self.classList.remove('is-fixed');
        }
      }
    }, { passive: true });
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
